import { FavouriteIcon } from '@tymbe/ui-icons';
import { CloseButtonProps, toast, ToastOptions } from 'react-toastify';

const toastOptionsBuilder = (
  onClose?: () => void,
  duration = 15
): ToastOptions => {
  return {
    autoClose: duration * 1000,
    onClose: onClose,
    position: 'top-center',
    closeButton: (closeProps: CloseButtonProps) => {
      return (
        <div className="cursor-pointer" onClick={closeProps.closeToast}>
          <FavouriteIcon name="close" className="size-4 ml-1" />
        </div>
      );
    },
  };
};

const SuccessAlert = (
  content: string,
  duration?: number,
  onClose?: () => void
) => toast.success(content, toastOptionsBuilder(onClose, duration));

const ErrorAlert = (content: string, duration?: number, onClose?: () => void) =>
  toast.error(content, toastOptionsBuilder(onClose, duration));

const InfoAlert = (content: string, duration?: number, onClose?: () => void) =>
  toast.info(content, toastOptionsBuilder(onClose, duration));

export { SuccessAlert, ErrorAlert, InfoAlert };
